module.exports = __webpack_public_path__ + "static/media/footerL.ff328888.png";